import { render } from "./ModuleSelection.vue?vue&type=template&id=74f2c403&scoped=true"
import script from "./ModuleSelection.vue?vue&type=script&lang=js"
export * from "./ModuleSelection.vue?vue&type=script&lang=js"

import "./ModuleSelection.vue?vue&type=style&index=0&id=74f2c403&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f2c403"]])

export default __exports__